import { useMsal } from "@azure/msal-react";
import { Avatar, type AvatarProps, Button, Divider, Menu, MenuItem, MenuTrigger, Text } from "@hopper-ui/components";
import { ExitIcon, KeyIcon, UserIcon } from "@hopper-ui/icons";
import { DisconnectIcon } from "@sg-protect/components";
import { navigateTo } from "@sg-protect/core";
import config from "@sg-protect/runtime-config";
import { useLegacyHomePaths } from "@sg-protect/shell";
import { useSession } from "./SessionProvider.tsx";

function handleLogout() {
    navigateTo(config.get().archives.logout);
}

export function UserMenu() {
    const { instance } = useMsal();
    const { account, subscription } = useLegacyHomePaths();

    const disconnectTenant = async () => {
        await instance.logout();
    };

    return (
        <MenuTrigger>
            <Button variant="ghost-secondary" aria-label="Open menu">
                <CurrentUserAvatar size="md" UNSAFE_width="2rem" UNSAFE_height="2rem" />
            </Button>

            <Menu size="xs">
                <MenuItem href={account}>
                    <UserIcon />
                    <Text>My account</Text>
                </MenuItem>

                <MenuItem href={subscription}>
                    <KeyIcon />
                    <Text>Subscription</Text>
                </MenuItem>

                {instance.getActiveAccount() !== null && (
                    <MenuItem onAction={disconnectTenant}>
                        <DisconnectIcon />
                        <Text>Disconnect tenant</Text>
                    </MenuItem>
                )}

                <MenuItem onAction={handleLogout}>
                    <ExitIcon />
                    <Text>Log out</Text>
                </MenuItem>

                <Divider />

                <MenuItem href="https://sharegate.com/terms" target="_blank">
                    <Text>Terms & Conditions</Text>
                </MenuItem>
            </Menu>
        </MenuTrigger>
    );
}

interface CurrentUserAvatarProps extends Omit<AvatarProps, "name"> {
    size?: AvatarProps["size"];
    width?: AvatarProps["width"];
    height?: AvatarProps["height"];
}

function CurrentUserAvatar(props: CurrentUserAvatarProps) {
    const { userDisplayName } = useSession();

    return <Avatar name={userDisplayName} {...props} />;
}
